import UIErrorMessage from '$shared/constants/UIErrorMessage';

export class ErrorMessage {
  public title: string;
  public message: string;
  public shouldPassToPlatformTeam: boolean;
  public sendToSentry: boolean;
  public ignoreErrorWhitelist: string[];
  public warnErrorWhiteList: string[];

  public customTitleObject: ObjectType<string>;

  constructor(
    title: string,
    sendToSentry?: boolean,
    shouldPassToPlatformTeam?: boolean,
    ignoreErrorWhitelist?: string[],
    warnErrorWhiteList?: string[]
  ) {
    this.title = title;
    this.shouldPassToPlatformTeam = !!shouldPassToPlatformTeam;
    this.sendToSentry = !!sendToSentry;
    this.ignoreErrorWhitelist = ignoreErrorWhitelist || [];
    this.warnErrorWhiteList = warnErrorWhiteList || [];
  }

  public setMessage(message: string): void {
    message && (this.message = message);
  }

  public setCustomTitleObject(list: ObjectType<string>): void {
    this.customTitleObject = list;
  }

  public toSentryData(): ObjectType<any> {
    return { shouldPassToPlatformTeam: this.shouldPassToPlatformTeam };
  }

  public setSendToSentry(sendToSentry: boolean): void {
    this.sendToSentry = sendToSentry;
  }

  public rewriteTitle(key: string): void {
    if (!key) return;
    this.customTitleObject?.[key] && (this.title = this.customTitleObject[key]);
  }

  static create(
    title: string,
    sendToSentry = false,
    shouldPassToPlatformTeam = false,
    ignoreErrorWhitelist: string[] = [],
    warnErrorWhiteList: string[] = [],
    customTitleObject?: ObjectType<string>
  ): ErrorMessage {
    const errorMessageObj = new ErrorMessage(
      title,
      sendToSentry,
      shouldPassToPlatformTeam,
      ignoreErrorWhitelist,
      warnErrorWhiteList
    );
    customTitleObject && errorMessageObj.setCustomTitleObject(customTitleObject);
    return errorMessageObj;
  }

  static forServerError(): ErrorMessage {
    return new ErrorMessage(UIErrorMessage.ServerErrorMessage, true, true);
  }
}
